import { createContext, useState, type Dispatch, type ReactNode, type SetStateAction } from 'react'

import type { FlashMessage } from '@axilon-apps/libs-ui-types'

export interface FlashMessagesContext {
  messages: FlashMessage[]
  setMessages: Dispatch<SetStateAction<FlashMessage[]>>
}

export const FlashMessagesContext = createContext<FlashMessagesContext>({
  messages: [],
  setMessages: () => {
    return
  }
})

export interface Props {
  children: ReactNode
}

export const FlashMessagesProvider = ({ children }: Props) => {
  const [messages, setMessages] = useState<FlashMessagesContext['messages']>([])

  return (
    <FlashMessagesContext.Provider
      value={{
        messages,
        setMessages
      }}
    >
      {children}
    </FlashMessagesContext.Provider>
  )
}

export const FlashMessagesConsumer = FlashMessagesContext.Consumer
